module.exports = __webpack_public_path__ + "static/media/tom-2.1d98c4ba.mp3";